import { FC } from 'react'
import { Box } from '@/components/atoms/Grid'
import { Body, Body3 } from '@/components/atoms/typography'
import CircleIcon from '@/components/molecules/circleIcon'
import styled from 'styled-components'

type InformationBadgeProps = {
  image: string
  title: string
  info: string
}

const InformationBadge: FC<InformationBadgeProps> = ({
  image,
  title,
  info
}) => (
  <Box width={{ desktop: '25%', tablet: '25%', mobile: '50%' }} pb={2}>
    <CircleIcon imageUrl={image} width={60} height={60} />
    <Body3 m={0} pt={3} textAlign="center">
      {title}
    </Body3>
    <StyledBody m={0} textAlign="center">
      {info}
    </StyledBody>
  </Box>
)

export default InformationBadge

const StyledBody = styled(Body)`
  line-height: 1.5;
`
